"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const emailHistorySlice_1 = __importDefault(require("../../email-history/emailHistorySlice"));
const assetDetailSlice_1 = __importStar(require("./assetDetailSlice"));
const assetVersionSlice_1 = __importDefault(require("./assetVersionSlice"));
const commentSlice_1 = __importDefault(require("./commentSlice"));
const ticketHistorySlice_1 = __importDefault(require("./ticketHistorySlice"));
const ticketSlice_1 = __importDefault(require("./ticketSlice"));
const reviewSlice_1 = __importDefault(require("./reviewSlice"));
const AssetDetailStore = (preloadedState) => {
    const reducers = (0, toolkit_1.combineReducers)({
        assetDetail: assetDetailSlice_1.default,
        assetComments: commentSlice_1.default,
        assetVersions: assetVersionSlice_1.default,
        ticketHistory: ticketHistorySlice_1.default,
        ticket: ticketSlice_1.default,
        emailHistory: emailHistorySlice_1.default,
        review: reviewSlice_1.default,
    });
    return (0, toolkit_1.configureStore)({
        devTools: {
            name: 'AssetDetail',
            actionCreators: { setIsDirty: assetDetailSlice_1.setIsDirty },
        },
        reducer: reducers,
        preloadedState,
        middleware: (getDefaultMiddleware) => 
        // assets uploaded are non-serializable data
        // this middleware is used to turn off redux-toolkit warnings
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    });
};
exports.default = AssetDetailStore;
